// Scheme-gate for operator- or catalog-supplied URLs used as href/src.
//
// React does not strip `javascript:` / `data:` from href, and the
// public showcase route is unauthenticated. Catalog productUrl, brand
// websiteUrl/logoUrl, and frozen snapshot cfg.logoUrl are tenant-writable
// with no scheme check. Only http: and https: are allowed; callers must
// render a plain-text label (or the non-image fallback) when this
// returns null, not a dead <a> / <img>.

export function safeHttpUrl(raw: unknown): string | null {
  if (typeof raw !== 'string') return null;
  const trimmed = raw.trim();
  if (!trimmed) return null;
  // Control chars let some parsers treat `javascript:` as the scheme
  // after a tab/newline/NUL prefix that `new URL` may still accept.
  if (/[\u0000-\u001F\u007F]/.test(trimmed)) return null;
  try {
    const url = new URL(trimmed);
    if (url.protocol !== 'http:' && url.protocol !== 'https:') return null;
    return url.href;
  } catch {
    return null;
  }
}
